var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSignature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3209_988",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3209_988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "signature",
    d: "M10.5563 8.79375C11.4688 8.11875 12.1813 7.37813 12.6938 6.57188C13.2063 5.76563 13.4625 4.9625 13.4625 4.1625C13.4625 3.7625 13.3969 3.46875 13.2656 3.28125C13.1344 3.09375 12.9563 3 12.7313 3C12.1438 3 11.625 3.49688 11.175 4.49063C10.725 5.48438 10.5 6.60625 10.5 7.85625C10.5 8.03125 10.5031 8.19688 10.5094 8.35313C10.5156 8.50938 10.5313 8.65625 10.5563 8.79375ZM2.25 15.75V14.25H3.75V15.75H2.25ZM5.25 15.75V14.25H6.75V15.75H5.25ZM8.25 15.75V14.25H9.75V15.75H8.25ZM11.25 15.75V14.25H12.75V15.75H11.25ZM14.25 15.75V14.25H15.75V15.75H14.25ZM2.55 12.75L1.5 11.7L2.7 10.5L1.5 9.3L2.55 8.25L3.75 9.45L4.95 8.25L6 9.3L4.8 10.5L6 11.7L4.95 12.75L3.75 11.55L2.55 12.75ZM11.5875 12C11.2125 12 10.8688 11.9281 10.5563 11.7844C10.2438 11.6406 9.975 11.4063 9.75 11.0813C9.4375 11.2563 9.11563 11.4125 8.78438 11.55C8.45313 11.6875 8.1125 11.825 7.7625 11.9625L7.2375 10.5563C7.5875 10.4313 7.92188 10.2969 8.24063 10.1531C8.55938 10.0094 8.86875 9.85625 9.16875 9.69375C9.10625 9.41875 9.05938 9.11875 9.02813 8.79375C8.99688 8.46875 8.98125 8.11875 8.98125 7.74375C8.98125 5.94375 9.3375 4.45313 10.05 3.27188C10.7625 2.09062 11.6563 1.5 12.7313 1.5C13.3813 1.5 13.9125 1.74063 14.325 2.22188C14.7375 2.70313 14.9438 3.375 14.9438 4.2375C14.9438 5.3125 14.6031 6.375 13.9219 7.425C13.2406 8.475 12.2938 9.41875 11.0813 10.2563C11.1688 10.3438 11.2594 10.4094 11.3531 10.4531C11.4469 10.4969 11.5438 10.5188 11.6438 10.5188C11.9688 10.5188 12.3469 10.3125 12.7781 9.9C13.2094 9.4875 13.6 8.94375 13.95 8.26875L15.3188 8.90625C15.2313 9.11875 15.1625 9.375 15.1125 9.675C15.0625 9.975 15.0688 10.2375 15.1313 10.4625C15.2563 10.4 15.4031 10.2938 15.5719 10.1438C15.7406 9.99375 15.9125 9.80625 16.0875 9.58125L17.2688 10.5C16.9438 10.95 16.5688 11.3125 16.1438 11.5875C15.7188 11.8625 15.325 12 14.9625 12C14.7 12 14.4656 11.9219 14.2594 11.7656C14.0531 11.6094 13.8813 11.3688 13.7438 11.0438C13.3938 11.3563 13.0375 11.5938 12.675 11.7563C12.3125 11.9188 11.95 12 11.5875 12Z",
    fill: "#4282E2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignature);
export default __webpack_public_path__ + "static/media/icon-signature.5c3260892259a0442e29e716ba6880be.svg";
export { ForwardRef as ReactComponent };